import { all } from 'redux-saga/effects';
import { mainSagas } from '../main/main-saga';
import { authSagas } from '../auth/auth-saga';
import { langSagas } from './language/lang-saga';
import { generalSagas } from './general/general-saga';
import { httpSagas } from '@ppvrbh/merchant-frontend-core';
import { branchSagas } from '../main/Screen/BranchManagement/redux/branch-saga';
import { userSagas } from '../main/Screen/UserManagement/redux/user-saga';
import { vatSagas } from '../main/Screen/VatAddress/redux/vat-saga';
import { catSagas } from '../main/Screen/FoodCategory/redux/cat-saga';
import { foodMenuSagas } from '../main/Screen/FoodMenu/redux/foodmenu-saga';
import { posSagas } from '../main/Screen/BranchManagement/PosManagement/redux/pos-saga';
import { reportSagas } from '../main/Screen/Report/redux/report-saga';
import { martCategorySagas } from '../main/Screen/MartCategory/redux/martCategory-saga';
import { martProductSagas } from '../main/Screen/MartProduct/redux/martProduct-saga';
import { deviceSagas } from '../main/Screen/DeviceManagement/redux/device-saga';
import { modifierItemSagas } from '../main/Screen/ModifierItem/redux/modifier-item-saga';
import { modifierGroupSagas } from '../main/Screen/ModifierGroup/redux/modifier-group-saga';
import { invitationSagas } from '../main/Screen/components/Invitation/redux/invitation-saga';

export function* rootSagas() {
  yield all([
    ...mainSagas.watchers,
    ...authSagas.watchers,
    ...langSagas.watchers,
    ...generalSagas.watchers,
    ...httpSagas.watchers,
    ...branchSagas.watchers,
    ...userSagas.watchers,
    ...vatSagas.watchers,
    ...catSagas.watchers,
    ...foodMenuSagas.watchers,
    ...posSagas.watchers,
    ...reportSagas.watchers,
    ...martCategorySagas.watchers,
    ...martProductSagas.watchers,
    ...deviceSagas.watchers,
    ...modifierItemSagas.watchers,
    ...modifierGroupSagas.watchers,
    ...invitationSagas.watchers,
  ]);
}
